import { contentSecurityPolicy as brandContentSecurityPolicy } from '@moonpig/web-core-brand/config'
import { PageContentSecurityPolicy } from '@moonpig/web-core-types'

export const defaultContentSecurityPolicy: PageContentSecurityPolicy = {
  'default-src': ["'none'"],
  'font-src': [
    "'self'",
    'data:',
    '*.gstatic.com', // Google Fonts
    '*.hotjar.com', // Hotjar
    '*.hotjar.io', // Hotjar
    '*.intercomcdn.com', // Intercom
  ].concat(brandContentSecurityPolicy['font-src']),
  'connect-src': [
    "'self'",
    'blob:',
    'sc-static.net', // Snapchat
    '*.adalyser.com', // Adalyser
    '*.adnxs.com', // AppNexus (Xandr)
    '*.adyen.com', // Adyen (Payments)
    'ak.sail-horizon.com', // Sailthru
    'api.sail-track.com', // Sailthru
    'api.sail-personalize.com', // Sailthru
    '*.bing.net', // Microsoft Bing
    '*.bing.com', // Microsoft Bing
    '*.clarity.ms', // Microsoft Bing
    'const.uno', // Podscribe
    '*.cookielaw.org', // Onetrust
    '*.criteo.com', // Criteo
    '*.criteo.net', // Criteo
    'data:',
    '*.doubleclick.net', // Google DoubleClick
    '*.facebook.com', // Facebook
    '*.google-analytics.com', // Google Analytics
    '*.google.co.uk', // Google
    'google.com', // Google
    '*.google.com', // Google
    '*.google.com.au', // Google
    '*.googleadservices.com', // Google Ad Services
    '*.googleapis.com', // Google APIs
    '*.googletagmanager.com', // Google Tag Manager
    '*.googlesyndication.com', // Google Syndication
    '*.mplat-ppcprotect.com', // Lunio
    '*.hotjar.com:*', // Hotjar
    '*.hotjar.com', // Hotjar
    '*.hotjar.io', // Hotjar
    '*.hs-analytics.net', // HubSpot
    '*.hsappstatic.net', // HubSpot
    '*.hs-banner.com', // HubSpot
    '*.hscollectedforms.net', // HubSpot
    '*.hs-scripts.com', // HubSpot
    '*.hsadspixel.net', // HubSpot
    '*.hubspot.com', // HubSpot
    '*.intercom.io', // Intercom
    '*.intercom-messenger.com', // Intercom Messenger
    '*.onetrust.com', // OneTrust
    '*.pangle-ads.com', // TikTok
    '*.paypal.com', // PayPal
    '*.pinterest.com', // Pinterest
    '*.podscribe.com', // Podscribe
    'px.ads.linkedin.com', // LinkedIn
    '*.reddit.com', // Reddit
    '*.redditstatic.com', // Reddit
    '*.rokt-api.com', // Rokt
    '*.rokt.com', // Rokt
    '*.rakuten', // Rakuten
    '*.sailthru.cloud', // Sailthru
    '*.sciencebehindecommerce.com', // Awin
    '*.snapchat.com', // Snapchat
    '*.snitcher.com', // Snitcher
    '*.sovendus.com', // Sovendus
    '*.sovendus-benefits.com', // Sovendus
    '*.speedcurve.com', // SpeedCurve
    '*.taboola.com', // Taboola
    '*.teads.tv', // Teads
    '*.tiktok.com', // TikTok
    '*.tiktokw.us', // TikTok
    '*.trackjs.com', // TrackJS
    '*.wepowerconnections.com', // Awin
    'wss://*.hotjar.com', // Hotjar
    'wss://*.intercom-messenger.com', // Intercom WebSocket
    'wss://*.intercom.io', // Intercom io WebSocket
  ].concat(brandContentSecurityPolicy['connect-src']),
  'frame-src': [
    "'self'",
    '*.adyen.com', // Adyen (Payments)
    '*.adsrvr.org', // Quantcast
    '*.awin1.com', // Awin
    '*.criteo.com', // Criteo
    '*.criteo.net', // Criteo
    '*.doubleclick.net', // Google DoubleClick
    '*.facebook.com', // Facebook
    '*.googleadservices.com', // Google Ad Services
    '*.googlesyndication.com', // Google Syndication
    '*.googletagmanager.com', // Google Tag Manager
    '*.hotjar.com', // Hotjar
    '*.hotjar.io', // Hotjar
    '*.hubspot.com', // HubSpot
    '*.hubspot.net', // HubSpot
    '*.hs-sites.com', // HubSpot
    '*.hsforms.net', // HubSpot
    '*.hsforms.com', // HubSpot
    '*.intercom.io', // Intercom
    '*.mplat-ppcprotect.com', // Lunio
    '*.paypal.com', // PayPal
    '*.paypalobjects.com', // PayPal
    '*.pinterest.com', // Pinterest
    '*.pinterest.co.uk', // Pinterest
    '*.rakuten.com', // Rakuten
    '*.roeye.com', // Awin
    '*.sovendus-benefits.com', // Sovendus
    '*.snapchat.com', // Snapchat
    '*.stripe.com', // Stripe
    '*.trustpilot.com', // Trustpilot
    '*.wepowerconnections.com', // Awin
    '*.youtube.com', // YouTube
    '*.zenaps.com', // Awin
  ].concat(brandContentSecurityPolicy['frame-src']),
  'style-src': [
    "'unsafe-inline'",
    "'self'",
    '*.adyen.com', // Adyen (Payments)
    '*.google.co.uk', // Google
    '*.google.com', // Google
    '*.googleapis.com', // Google APIs
    '*.googletagmanager.com', // Google Tag Manager
    '*.paypal.com', // PayPal
  ].concat(brandContentSecurityPolicy['style-src']),
  'img-src': ['*', 'data:', 'blob:'].concat(
    brandContentSecurityPolicy['img-src'],
  ),
  'script-src': [
    "'self'",
    "'unsafe-inline'",
    "'unsafe-eval'", // Awin required for https://www.dwin1.com/12199.js
    'd3dh5c7rwzliwm.cloudfront.net', // Cloudfront
    'd32106rlhdcogo.cloudfront.net', // Cloudfront
    'dgf0rw7orw6vf.cloudfront.net', // Cloudfront
    'd34r8q7sht0t9k.cloudfront.net', // Cloudfront
    '*.adalyser.com', // Adalyser
    '*.adnxs.com', // AppNexus (Xandr)
    '*.adyen.com', // Adyen (Payments)
    '*.adsrvr.org', // Quantcast
    '*.awin1.com', // Awin
    'ak.sail-horizon.com', // Sailthru
    '*.bing.net', // Microsoft Bing
    '*.bing.com', // Microsoft Bing
    '*.clarity.ms', // Microsoft Bing
    'const.uno', // Podscribe
    '*.cookielaw.org', // Onetrust
    '*.criteo.com', // Criteo
    '*.criteo.net', // Criteo
    '*.doubleclick.net', // Google DoubleClick
    '*.dwin1.com', // Awin
    '*.facebook.net', // Facebook
    '*.google-analytics.com', // Google Analytics
    '*.google.co.uk', // Google
    '*.google.com', // Google
    '*.google.com.au', // Google
    '*.googleadservices.com', // Google Ad Services
    '*.googlesyndication.com', // Google Syndication
    '*.googletagmanager.com', // Google Tag Manager
    '*.googletagservices.com', // Google Tag Services
    '*.hs-analytics.net', // HubSpot
    '*.hsappstatic.net', // HubSpot
    '*.hs-banner.com', // HubSpot
    '*.hscollectedforms.net', // HubSpot
    '*.hs-scripts.com', // HubSpot
    '*.hsadspixel.net', // HubSpot
    '*.hubspot.com', // HubSpot
    '*.hotjar.com', // Hotjar
    '*.hotjar.io', // Hotjar
    '*.intercom.io', // Intercom
    '*.intercomcdn.com', // Intercom CDN
    '*.mplat-ppcprotect.com', // Lunio
    '*.onetrust.com', // OneTrust
    '*.pangle-ads.com', // TikTok
    '*.paypal.com', // PayPal
    '*.paypalobjects.com', // PayPal
    '*.pinimg.com', // Pinterest
    '*.pinterest.com', // Pinterest
    '*.podscribe.com', // Podscribe
    'px.ads.linkedin.com', // LinkedIn
    '*.quantserve.com', // Quantcast
    '*.quantcount.com', // Quantcast
    '*.rakuten.com', // Rakuten
    '*.reddit.com', // Reddit
    '*.redditstatic.com', // Reddit
    '*.rokt-api.com', // Rokt
    '*.rokt.com', // Rokt
    '*.roeyecdn.com', // Awin
    'sc-static.net', // Snapchat
    '*.sciencebehindecommerce.com', // Awin
    '*.snapchat.com', // Snapchat
    'snap.licdn.com', // Linkedin
    '*.sovendus.com', // Sovendus
    '*.snitcher.com', // Snitcher
    '*.speedcurve.com', // SpeedCurve
    '*.stape.io', // Stape
    '*.stripe.com', // Stripe
    '*.taboola.com', // Taboola
    '*.teads.tv', // Teads
    '*.tiktok.com', // TikTok
    '*.trustpilot.com', // Trustpilot
    'unpkg.com', // Unpkg CDN
    '*.usemessages.com', // HubSpot
    '*.wepowerconnections.com', // Awin
    '*.youtube.com', // YouTube
    '*.zenaps.com', // Awin
  ].concat(brandContentSecurityPolicy['script-src']),
  'worker-src': [
    "'self'",
    '*.googletagmanager.com', // Google Tag Manager
  ].concat(brandContentSecurityPolicy['worker-src']),
  'child-src': [
    "'self'",
    '*.googletagmanager.com', // Google Tag Manager
  ].concat(brandContentSecurityPolicy['child-src']),
  'media-src': ['blob:'].concat(brandContentSecurityPolicy['media-src']),
}

export const generateContentSecurityPolicy = (
  csp?: PageContentSecurityPolicy,
) => {
  return {
    ...defaultContentSecurityPolicy,
    ...(csp || {}),
  }
}

export const generateCspString = (
  contentSecurityPolicy: PageContentSecurityPolicy,
): string =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.entries(contentSecurityPolicy)
    .filter(([, value]) => value && value.length > 0)
    .map(([property, rules]) => `${property} ${rules.join(' ')}`)
    .join(';')
